import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ElementRef,
  ComponentFactoryResolver,
  EventEmitter,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import {
  TareaCasoMixedModel,
  TareaCasoService,
} from 'src/app/services/tareacaso.service';
import { UploadFileService } from 'src/app/services/uploadfile.service';
import {
  CasoTareaModel,
  CasoTareaService,
} from 'src/app/services/casos_tareas.service';
import { TareaModel, TareasService } from 'src/app/services/tareas.service';
import { NotificacionService } from 'src/app/services/notificaciones.service';
import { ComponentDirective } from './directive/component.directive';
import { MatSnackBar } from '@angular/material/snack-bar';

import { first } from 'rxjs/operators';
import { RolService } from 'src/app/services/rol.service';
import { UserService } from 'src/app/services/user.service';
import { filter } from 'jszip';
import { RolesPermisosService } from 'src/app/services/roles_permisos.service';
import { COMPONENTS } from './constants/components.constant';
import { Subject } from 'rxjs';
import { EnvService } from 'src/app/services/env.service';
import { ModalFileShowViewComponent } from '../../shared/components/modal-file-show-view/modal-file-show-view.component';

@Component({
  selector: 'ver-tarea',
  templateUrl: './ver-tarea.component.html',
  styleUrls: ['./ver-tarea.component.scss'],
})
export class VerTareaComponent implements OnInit {
  user: string = sessionStorage.getItem('id_usuario');
  files: any[] = [];
  caso: CasoTareaModel = null;
  editar: boolean = false;
  textoGuardar = 'Guardar';
  idTareas: any = {};

  estafa: boolean = false;
  personalInterno: boolean = false;
  ingresosDescono: boolean = false;

  //
  correo;
  nombre;
  nm;
  //
  componentes = COMPONENTS;
  ComponentValue = null;
  componentRef: any;
  private timeOut: any;

  tareas: TareaModel[];
  tareasInvestigacionAsuntosInternos = [
    'Perfil - Reporte de delitos informáticos del CICPC',
    'Perfil - Datos migratorios (SAIME)',
    'Perfil - Datos residenciales (SENIAT-CNE)',
    'Perfil - Dirección y antecedentes laborales (Seguro social)',
    'Perfil - Datos filiatorios (Perfil como cliente de banco)',
    'Información de empleados y directorio interno de la empresa (Peoplesoft - Direm)',
    'Perfil - Cuentas otros bancos',
    'Perfil - Interacción de redes sociales',
    'Perfil - Rastreo de movimientos bancarios',
    'Perfil - Recabar evidencia del registro filmografico',
    'Personal - Entrevistar al indiciado',
    'Personal - Denunciar al indiciado',
    'Personal - Verificar si el indiciado está solicitado por una entidad policial',
    'Personal - Amonestación verbal o escrita',
    'Personal - Solicitud de renuncia/despido',
    'Personal - Remitir caso a Asuntos Laborales',
  ];

  @ViewChild('fileInput', { static: false }) fileInput: ElementRef;
  @ViewChild(ComponentDirective, { static: false })
  component!: ComponentDirective;
  emiteTareaGuardadaAlComponenteDinamico: Subject<void> = new Subject<void>();

  form: FormGroup = this.fb.group({
    observaciones_text: new FormControl({ value: '' }),
    personalInternoInvolucrado: [''],
    ingresosDescono: [''],
    estafa: [''],
    lastUser: [sessionStorage.getItem('correo')],
  });

  permisosStr: string = null;
  correo_usuario: string = sessionStorage.getItem('correo');
  includeAnalistaCasos: boolean;
  asignadoAlCaso: boolean;
  constructor(
    private env: EnvService,
    public dialogRef: MatDialogRef<VerTareaComponent>,
    public _casos: CasoTareaService,
    public _tareas: TareasService,
    public _tareacaso: TareaCasoService,
    @Inject(MAT_DIALOG_DATA) public tarea: TareaCasoMixedModel,
    public _fileUpload: UploadFileService,
    public _notificacion: NotificacionService,
    public fb: FormBuilder,
    private componentFactoyResolver: ComponentFactoryResolver,
    public _snackbar: MatSnackBar,
    public rolService: RolService,
    public userService: UserService,
    public _rolesPermisosService: RolesPermisosService,
    private readonly dialog: MatDialog
  ) {
    this.permisosStr = this.rolService.permisos.toString();
    if (
      this.permisosStr.includes('Analista de Casos Asuntos Internos') ||
      this.permisosStr.includes('Analista de Casos Asuntos Externos') ||
      this.permisosStr.includes('Analista de Casos Inteligencia') ||
      this.permisosStr.includes('analystRas') ||
      this.permisosStr.includes('Analista de Gestión de Fraudes')
    ) {
      this.includeAnalistaCasos = true;
    }
  }

  async getCaso() {
    return new Promise((resolve) => {
      this._casos.getById(this.tarea.idCaso).subscribe((response: any) => {
        this.caso = response;
        if (this.correo_usuario === this.caso.asignadoA) {
          this.asignadoAlCaso = true;
        } else if (
          (this.caso.tipo_caso == 'Autorización de transacciones' ||
            this.caso.tipo_caso == 'Validar Documento' ||
            // this.tarea.titulo == 'Verificación Saime' ||
            // this.tarea.titulo == 'Datos de Candidato' ||
            this.tarea.titulo ==
            'Caso de Robo o Hurto (Remitir a Consultoría Jurídica)') &&
          this.permisosStr.includes('Administrador Casos de Asuntos Externos')
        ) {
          this.asignadoAlCaso = true;
        }
        if (
          this.caso.tipo_caso == 'Gestión de casos VIP' &&
          this.permisosStr.includes('Admininistrador Casos de inteligencia')
        ) {
          this.includeAnalistaCasos = true;
        } else if (
          this.caso.tipo_caso == 'Autorización de transacciones' &&
          this.permisosStr.includes('Analista de Casos Asuntos Externos')
        ) {
          this.includeAnalistaCasos = false;
        }
        if (this.caso.tipo_caso === 'Investigación de asuntos internos')
          this.form.controls['personalInternoInvolucrado'].setValue(false);

        resolve(true);
      });
    });
  }

  async ngOnInit() {
    if (
      this.tarea.titulo != 'Detección de Acceso Irregular' &&
      this.tarea.titulo != 'Contacto con gerente de oficina'
    ) {
      this.showAdjuntos = true;
    }

    if (this.tarea.titulo == 'Verificación Saime') {
      this.textoGuardar = 'Validar';
    }
    await this.getCaso();

    const findIndex = this.componentes.findIndex(
      (componente) => componente.value === this.tarea.tabla
    );
    if (findIndex !== -1) {
      this.ComponentValue = this.componentes[findIndex];

      this.timeOut = setTimeout(() => {
        const componentFactoy =
          this.componentFactoyResolver.resolveComponentFactory<{ data: any }>(
            this.ComponentValue.component
          );

        console.log(this.component, 'CMPONENETS');
        const viewContainerRef = this.component.viewContainerRef;
        viewContainerRef.clear();
        this.componentRef = viewContainerRef.createComponent<{ data: any }>(
          componentFactoy
        );
        this.componentRef.instance.data = {
          task: JSON.parse(JSON.stringify(this.tarea)),
          personType: this.caso.personType,
        };
        this.componentRef.instance.saveEvent$ =
          this.emiteTareaGuardadaAlComponenteDinamico.asObservable();
      }, 10);
    }
    console.log('Esta es la tarea enviada', this.tarea);
    //
    if (
      (this.tarea.titulo ==
        'Caso de Robo o Hurto (Remitir a Consultoría Jurídica)' ||
        'Completar Datos de Solicitud (Autorización de transacciones)') &&
      this.permisosStr.includes('Administrador Casos de Asuntos Externos')
    ) {
      this.includeAnalistaCasos = true;
    }

    //
    sessionStorage.setItem('idCaso', this.tarea.idCaso);
    this.form.controls.observaciones_text.setValue(
      this.tarea.observaciones_text
    );
    this.form.controls.personalInternoInvolucrado.setValue(
      this.tarea.personalInternoInvolucrado
    );
    this.personalInterno =
      this.tarea.personalInternoInvolucrado === 'true' ? true : false;
    this.form.controls.estafa.setValue(this.tarea.estafa);
    this.estafa = this.tarea.estafa === 'true' ? true : false;
    this.form.controls.personalInternoInvolucrado.setValue(
      this.tarea.ingresosDescono
    );
    this.ingresosDescono = this.tarea.ingresosDescono === 'true' ? true : false;
    if (this.tarea.files) this.files = this.tarea.files;
    if (this.tarea.titulo === 'Aprobar Evaluación del Especialista')
      this.getIdTareasAprobacion();
    this.getIdTareasAprobacion(); //Coloco igualmente
  }

  showAdjuntos: boolean = false;
  async getIdTareasAprobacion() {
    const tareas = await this._tareas.get().toPromise();
    this.tareas = tareas;
    tareas.map((tarea: TareaModel) => {
      if (
        tarea.titulo === 'Realizar retencion de fondos y desbloqueo de cuentas.'
      )
        this.idTareas.realizarRetencion = tarea._id;
      if (tarea.titulo === 'Bloquear cuentas')
        this.idTareas.bloquearCuentas = tarea._id;
      if (
        tarea.titulo ===
        'Recibir confirmación de recuperación de fondos y reintegro al cliente.'
      )
        this.idTareas.recibirConfirmacion = tarea._id;
      if (tarea.titulo === 'Solicitar retencion de fondos en otros bancos.')
        this.idTareas.solicitarRetencionOB = tarea._id;
      if (tarea.titulo === 'Solicitar recuperación de los saldos retenidos.')
        this.idTareas.solicitarRecuperacion = tarea._id;
      if (tarea.titulo === 'Contacto con gerente de oficina')
        this.idTareas.contactoGerenteOficina = tarea._id;
      if (
        tarea.titulo ===
        'Elabora informe de resultado y adjunto comprobante de autorización'
      )
        this.idTareas.elaboraInformeResultadoAdjunto = tarea._id;
      if (
        tarea.titulo ===
        'Envía informe al Gerente de Administración de Clientes Internos a través de correo electrónico'
      )
        this.idTareas.enviaInformeGerenteAdministracion = tarea._id;
      if (tarea.titulo === 'Informe de resultado')
        this.idTareas.InformeResultado = tarea._id;
      if (tarea.titulo === 'Informe de acción irregular')
        this.idTareas.InformeAccionIrregular = tarea._id;
      if (tarea.titulo === 'Verificar Transferencia Interbancaria')
        this.idTareas.VerificarTransferenciaInterbancaria = tarea._id;
      if (tarea.titulo === 'Verificar Emision de Cheque de Gerencia')
        this.idTareas.VerificarEmisionChequeGerencia = tarea._id;
      if (tarea.titulo === 'Verificación Saime')
        this.idTareas.crearTareaVerificacionSaime = tarea._id;
      if (tarea.titulo === 'Verificación Candidato')
        this.idTareas.crearTareaVerificacionCandidato = tarea._id;

      if (tarea.titulo === 'Notificar al solicitante de la transaccion')
        this.idTareas.crearTareaNotificarSolicitanteTransaccion = tarea._id;
      if (tarea.titulo === 'Informar datos para transferencia de fondos')
        this.idTareas.crearTareaInformarTransferenciaFondos = tarea._id;
      if (tarea.titulo === 'Confirmación de recupero de fondos')
        this.idTareas.crearTareaConfirmaciónRecuperoFondos = tarea._id;

      if (tarea.titulo === 'Certificar Montos Reportados')
        this.idTareas.crearTareaCertificarMontosReportados = tarea._id;
    });
  }

  archivos_adjuntos() {
    this.fileInput.nativeElement.click();
  }

  onFile(event: any) {
    const files = event.target.files;
    for (let key of Object.keys(files)) {
      const file = files[key];
      this.uploadFile(file);
    }
  }

  async uploadFile(file: any) {
    const newfile = await this._fileUpload.upload(file).toPromise();
    this.files.push({ file_path: newfile.filename, filename: file.name });
  }

  async delete() {
    const tareaCasoDeleted = await this._tareacaso
      .delete(this.tarea.tareacasoId)
      .toPromise();
    this.dialogRef.close();
  }

  async goTo(url: any) {
    window.open(`${this.env.URL_API}/descargar/${url}`, '_blank');
  }

  async editarToggle() {
    this.editar = !!(
      (this.includeAnalistaCasos &&
        this.correo_usuario === this.caso.asignadoA &&
        (this.tarea.observaciones || this.tarea.archivos_adjuntos)) ||
      this.tarea.titulo === 'Aprobar Evaluación del Especialista'
    );
    if (this.editar) this.form.controls.observaciones_text.enable();
    if (this.editar) this.form.controls.personalInternoInvolucrado.enable();
    if (this.editar) this.form.controls.estafa.enable();
    else {
      this.form.controls.observaciones_text.disable();
      this.form.controls.personalInternoInvolucrado.disable();
      this.form.controls.estafa.disable();
    }
    this.form.value.files = this.files;
    await this._tareacaso
      .put(this.tarea.tareacasoId, this.form.value)
      .toPromise();
    this.caso.historial.push({
      usuario: `${sessionStorage.getItem('correo')}`,
      realizo: `Modifico la tarea "${this.tarea.titulo}"`,
      date: new Date(),
    });
    const newcaso = await this._casos.put(this.caso._id, this.caso).toPromise();
  }

  async deleteFile(filename: string) {
    this.files.map((file: any, i: number) => {
      if (file.filename === filename) this.files.splice(i, 1);
    });
    this.form.value.files = this.files;
    await this._tareacaso
      .put(this.tarea.tareacasoId, this.form.value)
      .toPromise();
    this.caso.historial.push({
      usuario: `${sessionStorage.getItem('correo')}`,
      realizo: `Modifico la tarea "${this.tarea.titulo}"`,
      date: new Date(),
    });
    const newcaso = await this._casos.put(this.caso._id, this.caso).toPromise();
  }

  createTask(idTarea: string) {
    this._tareacaso
      .post({
        idTarea,
        idCaso: this.caso._id,
        estado: 'Pendiente de realizar',
        deleted: false,
      })
      .toPromise();
  }

  crearTareaContactoGerenteOficina() {
    //Aqui se notifica al gerente que revise esta tarea
    //que tendra como formulario un si o no
    this._notificacion
      .solicitudCasoVipAprobacion(this.caso.creadoPor, this.caso.numero_caso)
      .pipe(first())
      .toPromise();

    this._tareacaso
      .post({
        idTarea: this.idTareas.contactoGerenteOficina,
        idCaso: this.caso._id,
        estado: 'Pendiente de realizar',
        deleted: false,
      })
      .toPromise();
  }
  crearTareaElaboraInformeResultadoAdjunto() {
    //Aqui se notifica al gerente que revise esta tarea
    //que tendra como formulario un si o no
    this._notificacion
      .solicitudCasoVipAprobacion(this.caso.creadoPor, this.caso.numero_caso)
      .pipe(first())
      .toPromise();
    this._tareacaso
      .post({
        idTarea: this.idTareas.elaboraInformeResultadoAdjunto,
        idCaso: this.caso._id,
        estado: 'Pendiente de realizar',
        deleted: false,
      })
      .toPromise();
  }

  crearTareaInformeResultado() {
    this._tareacaso
      .post({
        idTarea: this.idTareas.InformeResultado,
        idCaso: this.caso._id,
        estado: 'Pendiente de realizar',
        deleted: false,
      })
      .toPromise();
  }

  crearTareaInformeAccioirregular() {
    this._tareacaso
      .post({
        idTarea: this.idTareas.InformeAccionIrregular,
        idCaso: this.caso._id,
        estado: 'Pendiente de realizar',
        deleted: false,
      })
      .toPromise();
  }

  crearTareaVerificarTransferenciaInterbancaria() {
    this._tareacaso
      .post({
        idTarea: this.idTareas.VerificarTransferenciaInterbancaria,
        idCaso: this.caso._id,
        estado: 'Pendiente de realizar',
        deleted: false,
      })
      .toPromise();
  }
  crearTareaVerificarEmisionChequeGerencia() {
    this._tareacaso
      .post({
        idTarea: this.idTareas.VerificarEmisionChequeGerencia,
        idCaso: this.caso._id,
        estado: 'Pendiente de realizar',
        deleted: false,
      })
      .toPromise();
  }
  crearTareaVerificacionSaime() {
    this._tareacaso
      .post({
        idTarea: this.idTareas.crearTareaVerificacionSaime,
        idCaso: this.caso._id,
        estado: 'Pendiente de realizar',
        deleted: false,
      })
      .toPromise();
  }
  crearTareaVerificacionCandidato() {
    this._tareacaso
      .post({
        idTarea: this.idTareas.crearTareaVerificacionCandidato,
        idCaso: this.caso._id,
        estado: 'Pendiente de realizar',
        deleted: false,
      })
      .toPromise();
  }
  crearTareaNotificarSolicitanteTransaccion() {
    this._tareacaso
      .post({
        idTarea: this.idTareas.crearTareaNotificarSolicitanteTransaccion,
        idCaso: this.caso._id,
        estado: 'Pendiente de realizar',
        deleted: false,
      })
      .toPromise();
  }
  crearTareaInformarTransferenciaFondos() {
    this._tareacaso
      .post({
        idTarea: this.idTareas.crearTareaInformarTransferenciaFondos,
        idCaso: this.caso._id,
        estado: 'Pendiente de realizar',
        deleted: false,
      })
      .toPromise();
  }
  crearTareaConfirmaciónRecuperoFondos() {
    this._tareacaso
      .post({
        idTarea: this.idTareas.crearTareaConfirmaciónRecuperoFondos,
        idCaso: this.caso._id,
        estado: 'Pendiente de realizar',
        deleted: false,
      })
      .toPromise();
  }
  crearTareaCertificarMontosReportados() {
    this._tareacaso
      .post({
        idTarea: this.idTareas.crearTareaCertificarMontosReportados,
        idCaso: this.caso._id,
        estado: 'Pendiente de realizar',
        deleted: false,
      })
      .toPromise();
  }
  estafaC() {
    // this.estafa = !this.estafa
    this.form.controls.estafa.setValue('true');
    this.form.controls.personalInternoInvolucrado.setValue('');
    this.form.controls.ingresosDescono.setValue('');
  }

  personalInterC() {
    // this.personalInterno = !this.personalInterno
    this.form.controls.personalInternoInvolucrado.setValue('true');
    this.form.controls.estafa.setValue('');
    this.form.controls.ingresosDescono.setValue('');
  }

  ingresosDesconoC() {
    // this.ingresosDescono = !this.ingresosDescono
    this.form.controls.ingresosDescono.setValue('true');
    this.form.controls.estafa.setValue('');
    this.form.controls.personalInternoInvolucrado.setValue('');
  }

  asuntosInternosPersonalInternoInvolucrado(value) {
    this.form.controls['personalInternoInvolucrado'].setValue(value);
  }

  crearTareas() {
    if (this.form.value.estafa == 'true') {
      this.createTask(this.idTareas.realizarRetencion);
      this.createTask(this.idTareas.bloquearCuentas);

      this.caso.solucion = 'Estafa';
    }
    if (this.form.value.ingresosDescono == 'true') {
      this.createTask(this.idTareas.realizarRetencion);
      this.caso.solucion = 'Ingresos desconocidos';
    }
    if (this.form.value.personalInternoInvolucrado == 'true') {
      this.caso.solucion = 'Personal Interno Involucrado';
    }
    this.createTask(this.idTareas.recibirConfirmacion);
    this.createTask(this.idTareas.solicitarRecuperacion);
  }

  guardarHistorialModificacion() {
    if (this.tarea.titulo === 'Aprobar Evaluación del Especialista') {
      this.caso.historial.push({
        usuario: `${sessionStorage.getItem('correo')}`,
        realizo: `Módifico la tarea "${this.tarea.titulo}" con el comentario "${this.tarea.observaciones_text}"`,
        date: new Date(),
      });
    } else {
      this.caso.historial.push({
        usuario: `${sessionStorage.getItem('correo')}`,
        realizo: `Módifico la tarea "${this.tarea.titulo}"`,
        date: new Date(),
      });
    }
  }

  guardarHistorialAprobacion() {
    this.caso.historial.push({
      usuario: `${sessionStorage.getItem('correo')}`,
      realizo: `Aprobo el caso "${this.caso.numero_caso}"`,
      date: new Date(),
    });
  }

  private async verificarTipoDeCaso() {
    if (this.caso.tipo_caso === 'Retención de fondos') {
      this.crearTareas();
      this.guardarHistorialAprobacion();
      this.caso.aprobacion = false;

      if (this.form.value.personalInternoInvolucrado == 'true') {
        this.caso.remite = true;
        this.caso.historial.push({
          usuario: `${sessionStorage.getItem('correo')}`,
          realizo: `Indico Personal Interno Involucrado`,
          date: new Date(),
        });
        await this._casos.put(this.caso._id, this.caso).toPromise();
        let createCaso: any = {
          unidad: 'Asuntos Internos',
          tipo_caso: 'Recuperación de fondos: cuenta externa',
          descripcion: `Caso remitido de Inteligencia, por la existencia de personal interno involucrado:  ${this.nombre}, correo: ${this.correo}, nm: ${this.nm}`,
          asignadoA: '',
          files: [],
          asignadoAID: '',
          aprobacion: false,
          estado: 'Por Asignar',
          creadoPor: sessionStorage.getItem('id_usuario'),
          deleted: false,
          casoRemitido: this.caso._id,
          historial: [
            {
              usuario: `${sessionStorage.getItem('correo')}`,
              realizo: `Caso remitido de Inteligencia creado`,
              date: new Date(),
            },
          ],
        };
        this._casos.post(createCaso).subscribe(async (response: any) => {
          this._snackbar.open('Caso remitido a Asuntos internos', '❌');
        });
        this._rolesPermisosService
          .takeUser(['Administrador Casos de Asuntos Internos'])
          .subscribe((response) => {
            let users;
            users = response.payload.data;
            for (let user of users) {
              this._notificacion
                .notificacionPersonalInvolucrado(
                  user.id_usuarios,
                  this.caso.numero_caso,
                  { nombre: this.nombre, correo: this.correo, nm: this.nm }
                )
                .toPromise();
            }
          });
      } else if (this.form.value.personalInternoInvolucrado == '') {
        // this.userService.getUsers().subscribe((response:any)=>{
        //   users = response.payload.filter((data)=> {
        //     return data.id_roles == 6 ;
        //   })
        //   console.log(users)
        // })
        this._rolesPermisosService
          .takeUser(['Admininistrador Casos de inteligencia'])
          .subscribe((response) => {
            let users;
            users = response.payload.data;
            for (let user of users) {
              this._notificacion
                .notificacionNoPersonalInvolucrado(
                  user.id_usuarios,
                  this.caso.numero_caso
                )
                .toPromise();
            }
          });
      }
      //se envia el caso a asuntos internos ;'Investigación de asuntos internos'
      this.caso.estado = 'En Ejecución';
      this.form.value.estado = 'Finalizado';
      this._notificacion
        .aprobacion(this.caso.asignadoAID, this.caso.numero_caso)
        .toPromise();
    } else if (this.caso.tipo_caso === 'Investigación de asuntos internos') {
      if (this.form.value.personalInternoInvolucrado) {
        const tareas = this.tareas.filter(
          (tarea: TareaModel) =>
            this.tareasInvestigacionAsuntosInternos.indexOf(tarea.titulo) !== -1
        );
        for (let tarea of tareas) {
          this._tareacaso
            .post({
              idTarea: tarea._id,
              idCaso: this.caso._id,
              estado: 'Pendiente de realizar',
            })
            .toPromise();
        }
        this.guardarHistorialAprobacion();
        this.caso.estado = 'En Ejecución';
        this.caso.solucion = 'Personal Interno Involucrado';
      } else {
        this.caso.estado = 'Finalizado';
      }

      this.caso.aprobacion = false;
      this.form.value.estado = 'Finalizado';
      this._notificacion
        .aprobacion(this.caso.asignadoAID, this.caso.numero_caso)
        .toPromise();
    }
  }
  async guardar() {
    if (this.componentRef) {
      const { form } = this.componentRef.instance;

      if (form) {
        const { value, invalid } = form;
        console.log(value, invalid);
        if (invalid) {
          this._snackbar.open(
            'Error: Debe completar los campos requeridos (*)',
            '❌'
          );
          return;
        }
        this.form.value.data = value;
      }
    }

    switch (this.tarea.titulo) {
      case 'Aprobar Evaluación del Especialista':
        this.verificarTipoDeCaso();
        break;
      // case 'Detección de Acceso Irregular':
      //   if(this.form.value.data.accion_autorizada == "Si"){
      //     this.crearTareaContactoGerenteOficina()
      //   }else if(this.form.value.data.accion_autorizada == "No"){
      //    // this.crearTareaInformeResultado()
      //    this.crearTareaInformeAccioirregular()
      //   }
      //   break;
      case 'Evaluación Inicial del Caso':
        if (
          this.form.value.data.accion_autorizada == 'Si' ||
          this.form.value.data.accion_autorizada == 'No'
        ) {
          this.createTask(this.idTareas.enviaInformeGerenteAdministracion);

          this.crearTareaElaboraInformeResultadoAdjunto();
        }
        break;
      case 'Contacto con gerente de oficina':
        if (this.form.value.data.accion_autorizada == 'Si') {
          this.crearTareaInformeResultado();
        } else if (this.form.value.data.accion_autorizada == 'No') {
          //  this.crearTareaInformeAccioirregular()
          //Si da que no se pasa a auntos internos
          this.caso.unidad = 'Asuntos Internos';
          this._casos.put(this.caso._id, this.caso);
        }
        break;

      case 'Completar Datos de Solicitud (Autorización de transacciones)':
        if (this.form.value.data.tipo_validacion == 'Cheque de Gerencia') {
          this.crearTareaVerificarEmisionChequeGerencia();
        } else if ('Transferencia Interbancaria') {
          this.crearTareaVerificarTransferenciaInterbancaria();
        }
        break;

      case 'Datos de Candidato':
        this.crearTareaVerificacionSaime();
        break;

      case 'Verificación Saime':
        this.crearTareaVerificacionCandidato();
        break;

      case 'Solicitud de reintegro/entidad bancaria externa':
        if (this.form.value.data.aprobado == 'aprobado') {
          this.crearTareaInformarTransferenciaFondos();
          this.crearTareaConfirmaciónRecuperoFondos();
          this._rolesPermisosService
            .takeUser(['Administrador Casos de Asuntos Internos'])
            .subscribe((response) => {
              for (let userid of response.payload.data) {
                this._notificacion
                  .solicitudAprobacion(
                    userid.id_usuarios,
                    this.caso.numero_caso
                  )
                  .pipe(first())
                  .toPromise();
              }
            });
        } else if (this.form.value.data.aprobado == 'rechazado') {
          this.crearTareaNotificarSolicitanteTransaccion();
        }
        break;

      case 'Determinar Procedencia del Fraude':
        if (this.form.value.data.procedencia == 'Procedencia') {
          this.crearTareaCertificarMontosReportados();

          if (this.form.value.data.doble == 'Si') {
            this.caso.requiereDobleAprobacion = true;
            await this._casos.put(this.caso._id, this.caso).toPromise();
          } else {
            this.caso.requiereDobleAprobacion = false;
            await this._casos.put(this.caso._id, this.caso).toPromise();
          }
        } else if (this.form.value.data.procedencia == 'No Procedencia') {
          this._rolesPermisosService
            .takeUser(['Gerente Gestión de Fraudes'])
            .subscribe((response) => {
              let users;
              users = response.payload.data;
              for (let user of users) {
                this._notificacion
                  .notificacionNoProcedenciaCaso(
                    user.id_usuarios,
                    this.caso.numero_caso
                  )
                  .toPromise();
              }
            });
        }
        break;

      case 'Personal Interno Involucrado':
        if (!this.caso.remite) {
          this.caso.remite = true;
          this.caso.historial.push({
            usuario: `${sessionStorage.getItem('correo')}`,
            realizo: `Indico Personal Interno Involucrado`,
            date: new Date(),
          });
          await this._casos.put(this.caso._id, this.caso).toPromise();
          let createCaso: any = {
            unidad: 'Asuntos Internos',
            tipo_caso: 'Recuperación de fondos: cuenta externa',
            descripcion: `Caso remitido de Asuntos Externos, por la existencia de personal interno involucrado:  ${this.form.value.data.nombre}, cargo: ${this.form.value.data.cargo}, nm: ${this.form.value.data.NM}, descripción: ${this.form.value.data.descripcion}`,
            asignadoA: '',
            files: [],
            asignadoAID: '',
            aprobacion: false,
            estado: 'Por Asignar',
            creadoPor: sessionStorage.getItem('id_usuario'),
            deleted: false,
            casoRemitido: this.caso._id,
            historial: [
              {
                usuario: `${sessionStorage.getItem('correo')}`,
                realizo: `Caso remitido de Asuntos Externos creado`,
                date: new Date(),
              },
            ],
          };
          this._casos.post(createCaso).subscribe(async (response: any) => {
            this._notificacion
              .notificacionPersonalInvolucradoRolDeGuardia(
                this.caso.asignadoAID,
                this.caso.numero_caso,
                {
                  nombre: this.form.value.data.nombre,
                  nm: this.form.value.data.NM,
                }
              )
              .toPromise();
            this._snackbar.open('Caso remitido a Asuntos internos', '❌');
          });
        }
        break;

      default:
        this.guardarHistorialModificacion();
        break;
    }

    this.form.value.files = this.files;

    await this._tareacaso
      .put(this.tarea.tareacasoId, this.form.value)
      .toPromise();

    await this._casos.put(this.caso._id, this.caso).toPromise();
    this.dialogRef.close();
    if (this.tarea.titulo === 'Aprobar Evaluación del Especialista') {
      this.form.value.estado = 'Finalizado';
      await this._tareacaso
        .put(this.tarea.tareacasoId, this.form.value)
        .toPromise();
    }
    this.emiteTareaGuardadaAlComponenteDinamico.next();
  }
  view(file) {
          this.dialog
            .open(ModalFileShowViewComponent, {
              data: file,
              minWidth: '1%',
            })
            .afterClosed()
            .subscribe(async (re) => {});
    }
}
